import { render } from "./ClausePart.vue?vue&type=template&id=df42f23c&scoped=true"
import script from "./ClausePart.vue?vue&type=script&lang=js"
export * from "./ClausePart.vue?vue&type=script&lang=js"

import "./ClausePart.vue?vue&type=style&index=0&id=df42f23c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df42f23c"]])

export default __exports__